import type { PreloadProps } from 'react-relay';
import { nativeIssueTableEntryPoint } from '@jira/issue-table__issue-table/src/ui/nativeIssueTableEntryPoint.entrypoint.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from './__generated__/PlannerIssueListEmbedPageQuery$parameters.ts';
import type { PlannerIssueListEmbedPageQuery } from './__generated__/PlannerIssueListEmbedPageQuery.graphql.ts';
import type { PlannerIssueListEmbedEntryPoints } from './plannerIssueListEmbedEntryPoint.entrypoint.types.tsx';

const PAGE_SIZE = 50;

const PLANNER_ISSUE_LIST_FIELD_SET_IDS = [
	'issuetype',
	'issuekey',
	'summary',
	'parent',
	'status',
	'assignee',
	'issuelinks',
	'confluenceRemoteIssueLinks',
];

type Queries = {
	issueListQueryRef: PlannerIssueListEmbedPageQuery;
};

type ExtraProps = {
	jql: string;
};

export const plannerIssueListEmbedPreloadEntryPoint = (
	entryPointParams: EntryPointRouteParams,
): PreloadProps<EntryPointRouteParams, Queries, PlannerIssueListEmbedEntryPoints, ExtraProps> => {
	const { context, tenantContext } = entryPointParams;
	const jql = context.query.jql;

	if (jql == null || jql.trim() === '') {
		throw new Error('Planner issue list embed requires a non-empty jql query parameter');
	}

	return {
		queries: {
			issueListQueryRef: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					issueSearchInput: { jql },
					first: PAGE_SIZE,
					fieldSetsInput: {
						fieldSetIds: PLANNER_ISSUE_LIST_FIELD_SET_IDS,
					},
					fieldSetIds: PLANNER_ISSUE_LIST_FIELD_SET_IDS,
				},
			},
		},
		entryPoints: {
			nativeIssueTableEntryPoint: {
				entryPoint: nativeIssueTableEntryPoint,
				entryPointParams: {},
			},
		},
		extraProps: { jql },
	};
};
